import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { userStore } from '../utils/UserContext'
import ROUTES from '../utils/routes'

const Logout = () => {
  const history = useHistory()
  const { user, logout } = useContext(userStore)
  const [error, setError] = useState('')

  const performLogout = async () => {
    try {
      if (user) {
        await logout()
        history.push(ROUTES.user.login)
      }
    }
    catch (err) {
      setError(err.message)
    }
  }

  useEffect(() => {
    performLogout()
  }, [])

  return <div>{error !== '' ? <div>{error}</div> : null}</div>
}

export default Logout
